/* eslint-disable */
// TODO: Lint cleanup. If you are editing this file, it is your duty to fix all linting errors.
export const NAME = 'PERSON_COVERAGE'
